// Types
import {amount as amountType} from '@drivesally/sally-fn/lib/types';

export default ({driver: {deposit = 0} = {}} = {}) =>
  amountType(deposit).format();
